export default "__VITE_ASSET__Bj4mbUmE__$_?nuxt_component=async&nuxt_component_name=IconPaymentSofort&nuxt_component_export=default__"